import React from "react";
import "./Retail.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";
import {
    FiHome,
    FiChevronRight,
    FiShoppingBag,
} from "react-icons/fi";

const Retail = () => {

    return (

        <>

            <Header />

            {/* =====================================================
                            HERO SECTION
            ===================================================== */}

            <section className="retail-hero">

                <div className="retail-overlay"></div>

                <div className="container">

                    <div className="retail-hero-content">

                        <span className="retail-tag">
                            Retail Technology Solutions
                        </span>

                        <h1>
                            Empowering <span>Retail Businesses</span>
                            <br />
                            Through Smart Digital Solutions
                        </h1>

                        <p>
                            Kishancart Digital (OPC) Private Limited helps
                            retailers modernize their business with innovative
                            e-commerce platforms, retail management systems,
                            inventory automation, POS solutions, and
                            customer-focused digital experiences. Our scalable
                            technology enables businesses to improve
                            operations, increase sales, and deliver exceptional
                            shopping experiences across online and offline
                            channels.
                        </p>

                        {/* <div className="retail-hero-btns">

                            <NavLink
                                to="/contact"
                                className="primary-btn"
                            >
                                Get Started
                            </NavLink>

                            <NavLink
                                to="/services"
                                className="secondary-btn"
                            >
                                Explore Services
                            </NavLink>

                        </div> */}

                    </div>

                </div>

            </section>

            {/* =====================================================
                            BREADCRUMB
            ===================================================== */}

            <section className="retail-breadcrumb">

                <div className="container">

                    <div className="breadcrumb">

                        <NavLink to="/">
                            <FiHome />
                            Home
                        </NavLink>

                        <FiChevronRight />

                        <span>Solutions</span>

                        <FiChevronRight />

                        <span className="active">

                            <FiShoppingBag />

                            Retail

                        </span>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        NEXT PART STARTS HERE
                  Retail Overview + Retail Challenges
            ===================================================== */}

                        {/* =====================================================
                            RETAIL OVERVIEW
            ===================================================== */}

            <section className="retail-overview">

                <div className="container">

                    <div className="overview-grid">

                        {/* Left Content */}

                        <div className="overview-content">

                            <span className="section-tag">
                                Retail Digital Transformation
                            </span>

                            <h2>
                                Modern Retail Solutions for
                                <span> Smarter Business Growth</span>
                            </h2>

                            <p>
                                At Kishancart Digital (OPC) Private Limited,
                                we help retail businesses embrace digital
                                transformation with scalable technology
                                solutions that simplify operations, improve
                                customer engagement, and increase profitability.
                                Whether you operate a single retail outlet or
                                a nationwide chain, our solutions are designed
                                to grow with your business.
                            </p>

                            <p>
                                From e-commerce platforms and POS systems to
                                inventory management, CRM, billing software,
                                supplier management, and analytics dashboards,
                                we provide everything needed to build a
                                connected and efficient retail ecosystem.
                            </p>

                            <div className="overview-list">

                                <div className="overview-item">
                                    ✓ Multi-Store Retail Management
                                </div>

                                <div className="overview-item">
                                    ✓ Smart Inventory & Stock Control
                                </div>

                                <div className="overview-item">
                                    ✓ Omnichannel Commerce Solutions
                                </div>

                                <div className="overview-item">
                                    ✓ Customer Loyalty & CRM
                                </div>

                                <div className="overview-item">
                                    ✓ GST Billing & POS Integration
                                </div>

                                <div className="overview-item">
                                    ✓ Business Analytics & Reporting
                                </div>

                            </div>

                        </div>

                        {/* Right Cards */}

                        <div className="overview-cards">

                            <div className="overview-card">
                                <h3>Retail ERP</h3>
                                <p>
                                    Manage inventory, purchasing, sales,
                                    suppliers, and billing from one platform.
                                </p>
                            </div>

                            <div className="overview-card">
                                <h3>E-Commerce Platform</h3>
                                <p>
                                    Launch scalable online stores with secure
                                    payments and seamless customer experiences.
                                </p>
                            </div>

                            <div className="overview-card">
                                <h3>Inventory Automation</h3>
                                <p>
                                    Track stock levels, warehouse movement,
                                    and product availability in real time.
                                </p>
                            </div>

                            <div className="overview-card">
                                <h3>Retail Analytics</h3>
                                <p>
                                    Gain actionable insights into sales,
                                    customer behavior, and business
                                    performance.
                                </p>
                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                            RETAIL CHALLENGES
            ===================================================== */}

            <section className="retail-challenges">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Business Challenges
                        </span>

                        <h2>
                            Challenges Faced by
                            <span> Modern Retailers</span>
                        </h2>

                        <p>
                            Retail businesses operate in a competitive
                            environment where efficient operations and
                            exceptional customer experiences are essential for
                            success. Our technology helps solve these common
                            business challenges.
                        </p>

                    </div>

                    <div className="challenge-grid">

                        <div className="challenge-card">
                            <h3>Inventory Tracking</h3>
                            <p>
                                Prevent stock shortages and overstocking with
                                real-time inventory visibility.
                            </p>
                        </div>

                        <div className="challenge-card">
                            <h3>Manual Billing</h3>
                            <p>
                                Replace slow manual billing with fast,
                                automated POS and GST-compliant invoicing.
                            </p>
                        </div>

                        <div className="challenge-card">
                            <h3>Customer Retention</h3>
                            <p>
                                Build lasting customer relationships through
                                loyalty programs and personalized engagement.
                            </p>
                        </div>

                        <div className="challenge-card">
                            <h3>Multi-Store Operations</h3>
                            <p>
                                Manage multiple branches, warehouses, and
                                retail outlets from a centralized platform.
                            </p>
                        </div>

                        <div className="challenge-card">
                            <h3>Sales Reporting</h3>
                            <p>
                                Monitor revenue, product performance, and
                                business KPIs with interactive dashboards.
                            </p>
                        </div>

                        <div className="challenge-card">
                            <h3>Online & Offline Integration</h3>
                            <p>
                                Synchronize physical stores with e-commerce
                                platforms for a unified shopping experience.
                            </p>
                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        NEXT PART STARTS HERE
                Our Retail Solutions + Key Features
            ===================================================== */}

            {/* =====================================================
                            OUR RETAIL SOLUTIONS
            ===================================================== */}

            <section className="retail-solutions">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Retail Solutions
                        </span>

                        <h2>
                            Complete Digital Solutions for
                            <span> Modern Retail Businesses</span>
                        </h2>

                        <p>
                            We build intelligent retail software that helps
                            businesses streamline operations, improve customer
                            experiences, and maximize profitability across
                            online and offline channels.
                        </p>

                    </div>

                    <div className="solutions-grid">

                        <div className="solution-card">
                            <h3>Point of Sale (POS)</h3>
                            <p>
                                Fast billing, GST invoices, barcode support,
                                and seamless checkout for retail stores.
                            </p>
                        </div>

                        <div className="solution-card">
                            <h3>Inventory Management</h3>
                            <p>
                                Monitor stock levels, warehouses, and product
                                availability with real-time inventory tracking.
                            </p>
                        </div>

                        <div className="solution-card">
                            <h3>Retail ERP</h3>
                            <p>
                                Manage purchasing, inventory, sales,
                                suppliers, finance, and operations from one
                                centralized system.
                            </p>
                        </div>

                        <div className="solution-card">
                            <h3>CRM Solutions</h3>
                            <p>
                                Strengthen customer relationships with loyalty
                                programs, purchase history, and personalized
                                marketing.
                            </p>
                        </div>

                        <div className="solution-card">
                            <h3>E-Commerce Platform</h3>
                            <p>
                                Launch secure online stores with integrated
                                payments, order management, and delivery
                                tracking.
                            </p>
                        </div>

                        <div className="solution-card">
                            <h3>Marketplace Management</h3>
                            <p>
                                Connect multiple sellers, products, and
                                customers through scalable multi-vendor
                                marketplace solutions.
                            </p>
                        </div>

                        <div className="solution-card">
                            <h3>Analytics Dashboard</h3>
                            <p>
                                Visualize sales, revenue, inventory trends,
                                and customer insights with interactive
                                dashboards.
                            </p>
                        </div>

                        <div className="solution-card">
                            <h3>Mobile Commerce</h3>
                            <p>
                                Deliver engaging Android and iOS shopping
                                applications for customers and business owners.
                            </p>
                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                            KEY FEATURES
            ===================================================== */}

            <section className="retail-features">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Key Features
                        </span>

                        <h2>
                            Everything Your Retail Business
                            <span> Needs</span>
                        </h2>

                        <p>
                            Our retail platforms are equipped with powerful
                            features that simplify daily operations while
                            supporting business growth and customer
                            satisfaction.
                        </p>

                    </div>

                    <div className="features-grid">

                        <div className="feature-card">
                            <h3>Real-Time Inventory</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Barcode Management</h3>
                        </div>

                        <div className="feature-card">
                            <h3>GST Billing System</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Supplier Management</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Purchase Management</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Sales Analytics</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Customer Database</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Loyalty Programs</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Staff Management</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Multi-Branch Support</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Online Order Management</h3>
                        </div>

                        <div className="feature-card">
                            <h3>Business Reports</h3>
                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE
             Benefits + Industries + Technology Stack + Footer
            ===================================================== */}

                        {/* =====================================================
                        BUSINESS BENEFITS
            ===================================================== */}

            <section className="retail-benefits">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Business Benefits
                        </span>

                        <h2>
                            Why Retailers Choose
                            <span> Kishancart Digital</span>
                        </h2>

                        <p>
                            Our retail technology solutions are designed to help
                            businesses streamline operations, improve customer
                            experiences, and achieve sustainable growth through
                            intelligent automation and digital innovation.
                        </p>

                    </div>

                    <div className="benefits-grid">

                        <div className="benefit-card">

                            <h3>Increase Sales</h3>

                            <p>
                                Expand your business through integrated online
                                and offline sales channels, personalized
                                customer experiences, and smarter marketing
                                strategies.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Reduce Operational Costs</h3>

                            <p>
                                Automate billing, inventory management,
                                purchasing, and reporting to minimize manual
                                work and improve overall operational
                                efficiency.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Better Customer Experience</h3>

                            <p>
                                Deliver faster service, secure checkout,
                                personalized offers, and seamless shopping
                                experiences across every customer touchpoint.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Real-Time Business Insights</h3>

                            <p>
                                Monitor sales performance, inventory,
                                purchasing trends, and customer behavior using
                                interactive dashboards and intelligent reports.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Scalable Retail Operations</h3>

                            <p>
                                Easily manage multiple stores, warehouses,
                                suppliers, and online marketplaces from one
                                centralized platform as your business grows.
                            </p>

                        </div>

                        <div className="benefit-card">

                            <h3>Secure & Future-Ready Solutions</h3>

                            <p>
                                Build your retail business on secure, scalable,
                                and cloud-ready technology designed to support
                                long-term growth and digital transformation.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />

        </>

    );

};

export default Retail;